
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { IPageData, ICol } from './PublicTable'
import PublicTableItem from './PublicTableItem.vue'

@Component({
  components: {
    PublicTableItem,
  },
})
export default class PublicTable extends Vue {
  /** table list 数据 */
  @Prop({ type: Array, default: () => [] }) data!: any[]
  /** table cols 数据 */
  @Prop({ type: Array, default: () => [] }) cols!: ICol[]
  /** 是否显示合计行 */
  @Prop({ type: Boolean, default: false }) showSummary!: boolean
  /** 是否加载中 */
  @Prop({ type: Boolean, default: false }) isLoading!: boolean
  /** 是否显示分页 */
  @Prop({ type: Boolean, default: true }) isPagination!: boolean
  /** col 最小宽度 */
  @Prop({ type: [String, Number], default: '100' }) colMinWidth!: string|number
  /** 分页数据 */
  @Prop({
    type: Object,
    default: () => {
      return {
        pageSize: 10,
        pageNum: 1,
        pageCount: 0,
        hasPrevPage: false,
        hasNextPage: false,
      }
    },
  })
  pageData!: IPageData
  public tableNode: any = {}
  public mounted() {
    this.$nextTick(() => {
      this.tableNode = this.$refs.tableNode
    })
  }
}
